import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import ProductProvider from 'providers/ProductProvider';
import CourseProvider from 'providers/CourseProvider';
import ModalAuth from 'components/authentication/modal/ModalAuth';

import PropTypes from 'prop-types';
import { useAppContext } from 'providers/AppProvider';
import {
  Button,
  Col,
  Form,
  FormControl,
  InputGroup,
  Offcanvas
} from 'react-bootstrap';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getCustomerTableList } from 'nursd-dashboard/api/customerTable';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllHospitalOrgList } from 'nursd-dashboard/api/organizationTable';
import moment from 'moment';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition, isDrawerOpen },
    setConfig
  } = useAppContext();

  const { authToken, location, organization } = useAuth();
  const [filter, setFilter] = useState({
    status: 'Both',
    search: '',
    filter: false
  });

  const [filterHos, setFilterHos] = useState({
    status: 'Both',
    search: '',
    filter: false
  });

  const [tab, setTab] = useState('Patient');
  const [customers, setCustomers] = useState([]);
  const [hospital, setHospital] = useState([]);

  const getCustomer = async () => {
    try {
      const cusList = await getCustomerTableList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          name: item.firstName + ' ' + item.lastName,
          avatar: {
            name: item.firstName + ' ' + item.lastName
          },
          email: item.email,
          password: item.password,
          address: item.fullAddress,
          phone: item.phoneOne,
          status: item?.active,
          joined: item.createdAt,
          mrn: item?.additionalFields[0]?.mrnNumber,
          dateOfBirth: item?.additionalFields[0]?.dateOfBirth,
          original: item
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setCustomers(array);
      }
    } catch (error) {
      setCustomers([]);
    }
  };

  const getHospital = async () => {
    try {
      const cusList = await getAllHospitalOrgList(
        authToken,
        location,
        organization
      );
      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          name: item?.additionalFields[0].facilityName,
          avatar: {
            name: item.firstName + ' ' + item.lastName
          },
          email: item.emailId,
          contact: item.firstName + ' ' + item.lastName,
          hospitalLoginControl: item?.hospitalLoginControl,
          original: item
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setHospital(array);
      }
    } catch (error) {
      setHospital([]);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    getCustomer();
    getHospital();
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const PatientCard = ({ item }) => {
    return (
      <div className="mx-1 p-1">
        <Flex alignItems="center">
          <Link
            to={paths.customer_profile(item?.id)}
            onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
          >
            {item?.avatar.img ? (
              <Avatar
                src={item?.avatar.img}
                size="2xl"
                className={`me-2 status-${item?.status ? 'online' : 'offline'}`}
              />
            ) : (
              <Avatar
                size="2xl"
                name={item?.avatar.name}
                className={`me-2 status-${item?.status ? 'online' : 'offline'}`}
              />
            )}
          </Link>
          <div className="flex-1">
            <Link
              to={paths.customer_profile(item?.id)}
              onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
            >
              <h5 className="mb-0 fs-10">{item?.name}</h5>
            </Link>
            <h5 className="mb-0 fs-11">MRN: {item?.mrn}</h5>
            <h5 className="mb-0 fs-11">
              {moment(item?.dateOfBirth).format('MM-DD-YYYY')}
            </h5>
          </div>
        </Flex>
      </div>
    );
  };

  PatientCard.propTypes = {
    item: PropTypes.any
  };

  const HospitalCard = ({ item }) => {
    return (
      <div className="mx-1 p-1">
        <Flex alignItems="center">
          <Link
            to={paths.nursd_facility}
            onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
          >
            {item?.avatar.img ? (
              <Avatar
                src={item?.avatar.img}
                size="2xl"
                className={`me-2 status-${
                  !item?.hospitalLoginControl ? 'online' : 'offline'
                }`}
              />
            ) : (
              <Avatar
                size="2xl"
                name={item?.avatar.name}
                className={`me-2 status-${
                  !item?.hospitalLoginControl ? 'online' : 'offline'
                }`}
              />
            )}
          </Link>
          <div className="flex-1">
            <Link
              to={paths.nursd_facility}
              onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
            >
              <h5 className="mb-0 fs-10">{item?.name}</h5>
            </Link>
            <h5 className="mb-0 fs-11">
              {item?.contact}-{item?.original?.phoneNumber}
            </h5>
          </div>
        </Flex>
      </div>
    );
  };

  HospitalCard.propTypes = {
    item: PropTypes.any
  };

  const filterData = data => {
    return data?.filter(item =>
      item?.name?.toLowerCase().includes(filter.search?.toLowerCase())
    );
  };

  const filterDataHos = data => {
    return data?.filter(item =>
      item?.name?.toLowerCase().includes(filter.search?.toLowerCase())
    );
  };

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <ProductProvider>
        <CourseProvider>
          <div className={classNames('content', { 'pb-0': isKanban })}>
            <NavbarTop />
            {/*------ Main Routes ------*/}
            <Outlet />
            <Offcanvas
              show={isDrawerOpen}
              placement={'end'}
              onHide={() => setConfig('isDrawerOpen', !isDrawerOpen)}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                  <div
                    style={{
                      display: 'flex'
                    }}
                  >
                    <h5
                      style={{
                        color: tab === 'Patient' ? '#000' : '#888',
                        cursor: 'pointer',
                        borderBottomWidth: tab === 'Patient' ? 3 : 0,
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#00B0F0',
                        paddingBottom: 5
                      }}
                      onClick={() => setTab('Patient')}
                    >
                      Patient
                    </h5>

                    <h5
                      style={{
                        color: tab === 'Hospital' ? '#000' : '#888',
                        cursor: 'pointer',
                        marginLeft: 10,
                        borderBottomWidth: tab === 'Hospital' ? 3 : 0,
                        borderBottomStyle: 'solid',
                        borderBottomColor: '#00B0F0',
                        paddingBottom: 5
                      }}
                      onClick={() => setTab('Hospital')}
                    >
                      Facility
                    </h5>
                  </div>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {tab === 'Patient' ? (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end'
                      }}
                    >
                      <InputGroup className={'position-relative'}>
                        <FormControl
                          value={filter?.search}
                          onChange={({ target: { value } }) => {
                            setFilter({ ...filter, search: value });
                          }}
                          size="sm"
                          id="search"
                          placeholder={'Search...'}
                          type="search"
                          className="shadow-none"
                        />
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          className="border-300 hover-border-secondary"
                          onClick={() =>
                            setFilter({ ...filter, filter: !filter.filter })
                          }
                        >
                          <FontAwesomeIcon icon="filter" className="fs-10" />
                        </Button>
                      </InputGroup>
                      <Button
                        size="sm"
                        as={Link}
                        to={paths.nursd_customer_form}
                        onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
                      >
                        Add
                      </Button>
                    </div>
                    {filter.filter && (
                      <Form className="mx-1 mt-1">
                        <Form.Group as={Col} md="12" controlId="checkbox2">
                          <Form.Check
                            type="checkbox"
                            id="defaultCheckbox2"
                            label="Active Patients"
                            checked={filter.status === 'Active' ? true : false}
                            onChange={() =>
                              setFilter({
                                ...filter,
                                status:
                                  filter.status === 'Active' ? '' : 'Active'
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="12" controlId="checkbox3">
                          <Form.Check
                            type="checkbox"
                            id="defaultCheckbox3"
                            label="In-Active Patients"
                            checked={
                              filter.status === 'In-Active' ? true : false
                            }
                            onChange={() =>
                              setFilter({
                                ...filter,
                                status:
                                  filter.status === 'In-Active'
                                    ? ''
                                    : 'In-Active'
                              })
                            }
                          />
                        </Form.Group>
                      </Form>
                    )}
                    <div className="mt-2">
                      {filterData(customers)
                        ?.filter(i =>
                          filter.status === 'Active'
                            ? i?.status
                            : filter.status === 'In-Active'
                            ? !i?.status
                            : i
                        )
                        ?.map((item, index) => {
                          return (
                            <div key={index}>
                              <PatientCard item={item} />
                            </div>
                          );
                        })}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end'
                      }}
                    >
                      <InputGroup className={'position-relative'}>
                        <FormControl
                          value={filter?.search}
                          onChange={({ target: { value } }) => {
                            setFilterHos({ ...filterHos, search: value });
                          }}
                          size="sm"
                          id="search"
                          placeholder={'Search...'}
                          type="search"
                          className="shadow-none"
                        />
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          className="border-300 hover-border-secondary"
                          onClick={() =>
                            setFilterHos({
                              ...filterHos,
                              filter: !filterHos.filter
                            })
                          }
                        >
                          <FontAwesomeIcon icon="filter" className="fs-10" />
                        </Button>
                      </InputGroup>
                      <Button
                        size="sm"
                        as={Link}
                        to={paths.nursd_facility_form}
                        onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
                      >
                        Add
                      </Button>
                    </div>
                    {filterHos.filter && (
                      <Form className="mx-1 mt-1">
                        <Form.Group as={Col} md="12" controlId="checkbox2">
                          <Form.Check
                            type="checkbox"
                            id="defaultCheckbox2"
                            label="Active Facility"
                            checked={
                              filterHos.status === 'Active' ? true : false
                            }
                            onChange={() =>
                              setFilterHos({
                                ...filterHos,
                                status:
                                  filterHos.status === 'Active' ? '' : 'Active'
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="12" controlId="checkbox3">
                          <Form.Check
                            type="checkbox"
                            id="defaultCheckbox3"
                            label="In-Active Facility"
                            checked={
                              filterHos.status === 'In-Active' ? true : false
                            }
                            onChange={() =>
                              setFilterHos({
                                ...filterHos,
                                status:
                                  filterHos.status === 'In-Active'
                                    ? ''
                                    : 'In-Active'
                              })
                            }
                          />
                        </Form.Group>
                      </Form>
                    )}
                    <div className="mt-2">
                      {filterDataHos(hospital)
                        ?.filter(i =>
                          filterHos.status === 'Active'
                            ? !i?.hospitalLoginControl
                            : filterHos.status === 'In-Active'
                            ? i?.hospitalLoginControl
                            : i
                        )
                        ?.map((item, index) => {
                          return (
                            <div key={index}>
                              <HospitalCard item={item} />
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
              </Offcanvas.Body>
            </Offcanvas>
            {!isKanban && <Footer />}
          </div>
        </CourseProvider>
      </ProductProvider>
      <ModalAuth />
    </div>
  );
};

export default MainLayout;
